import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import {
  EVENT_DISCORD_AUTH,
  EVENT_X_AUTH,
  PusherService
} from '../services/pusherService'
import {
  changeEarnViaState,
  handleSocialLoginStatus
} from '../store/actions/earnVia'
import { EARN_VIA_PROFILE_DISPATCH } from '../store/reducers/earnVia/earnVia'
import { selectEarnViaProfile } from '../store/selectors/common'
import { commonParser } from '../util/apiParser.helpers'
import { closeWindow } from '../util/app/app.helpers'
import { isRedirectScreen } from '../util/navigation.helpers'
import { buildConnectXError } from '../util/wallet/common.helpers'
import { CUSTOM_BRAND_ID } from '../constants/pointsExchange'

const usePusherEvents = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { channelName } = useSelector(selectEarnViaProfile)

  const discordChannel = channelName[CUSTOM_BRAND_ID.DISCORD]
  const xChannel = channelName[CUSTOM_BRAND_ID.X]

  const handlePusherEvent = (brandId, data) => {
    const parsedData = commonParser(data)
    if (parsedData?.error) {
      closeWindow()
      dispatch(
        changeEarnViaState(EARN_VIA_PROFILE_DISPATCH.ERROR, {
          [brandId]: buildConnectXError(parsedData.error.message)
        })
      )
      dispatch(changeEarnViaState(EARN_VIA_PROFILE_DISPATCH.CONNECTING, false))
    } else if (parsedData?.data) {
      closeWindow()
      dispatch(handleSocialLoginStatus(brandId, parsedData.data))
    }
  }

  useEffect(() => {
    const pusherService = PusherService.getInstance()
    if (!discordChannel || isRedirectScreen(location)) return

    const handleDiscord = (data) => {
      handlePusherEvent(CUSTOM_BRAND_ID.DISCORD, data)
    }

    pusherService.subscribe(discordChannel, EVENT_DISCORD_AUTH, handleDiscord)

    return () => {
      pusherService.unsubscribe(discordChannel)
    }
  }, [discordChannel, location])

  useEffect(() => {
    const pusherService = PusherService.getInstance()
    if (!xChannel || isRedirectScreen(location)) return

    const handleX = (data) => {
      handlePusherEvent(CUSTOM_BRAND_ID.X, data)
    }

    pusherService.subscribe(xChannel, EVENT_X_AUTH, handleX)

    return () => {
      pusherService.unsubscribe(xChannel)
    }
  }, [xChannel, location])

  return null
}

export { usePusherEvents }
